export default __webpack_public_path__ + "static/media/triangle-icon.69eade52.svg";